module.exports = __webpack_public_path__ + "static/media/close.1756c568.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/close.svg
// module id = 419
// module chunks = 2